import axios from 'axios'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 60000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer ' + token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const apiFileClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: true,
  headers: {
    Accept: 'application/pdf',
    'Content-type': 'application/json'
  },
  responseType: 'blob'
})

apiFileClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer ' + token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default {
  signUpInCebelca(body) {
    return apiClient.post('/cebelca/signup', body)
  },
  fiscalizeInvoice(body) {
    return apiClient.post('/cebelca/invoice/fiscalize', body)
  },
  fetchInvoicePDF(cebelcaInvoiceId) {
    return apiFileClient.get(`/cebelca/invoice/pdf?invoice_id=${cebelcaInvoiceId}`)
  },
  uploadCebelcaCertificate(formData) {
    const url = `${process.env.VUE_APP_API_URL}/cebelca/certificate`
    return axios.post(url, formData)
  },
  checkFiscalisationCertUploaded() {
    return apiClient.get(`/cebelca/check/certificate`)
  },
  connectCebelcaAccount(body) {
    return apiClient.post('/cebelca/account/connect', body)
  }
}
